var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fadeBottom"}},[_c('div',{staticClass:"clearfix"},[(!_vm.img)?_c('div',{staticClass:"msg p-mess",class:{'msg--human':_vm.human, 'msg--popup':_vm.popup}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e(),_vm._v(" "),(_vm.img)?_c('div',{staticClass:"msg__img p-image"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imgDynamic}})]):_vm._e()])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee383954","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/component/game/msg/msg.html
// module id = 400
// module chunks = 0